// extracted by mini-css-extract-plugin
export default {"error":"styles_error__Eeb9B","warning":"styles_warning__vGijM"};